export default __webpack_public_path__ + "fonts/text-h5.9b6cf8400baf15fc2ac3a8c4bf98c69e.png";